import React from "react";

interface Props {
  status: "APPROVED" | "DRAFTING" | "REJECT";
}

export function TableHeader({ status }: Props) {
  return (
    <thead>
      <tr>
        <th>No.</th>
        <th className="text-center">Image</th>
        <th className="text-center" style={{ width: 50 }}>
          Additional Image
        </th>
        <th>Title</th>
        <th>Supplier Code</th>
        {status === "APPROVED" && <th>Sale Info</th>}
        <th>Stock</th>
        <th className="text-center">Color</th>
        <th className="text-center">Size</th>
        <th className="text-center">{status === "APPROVED" ? "Price before discount" : "Price"}</th>
        {status === "APPROVED" && <th className="text-center">Discount</th>}
        {status === "APPROVED" && <th className="text-right">Price after discount</th>}
        {status === "REJECT" && <th>Rejected Reason</th>}
        {status === "APPROVED" && (
          <th className="text-center" style={{ width: 233 }}>
            Tags <br /> <small className="text-danger">(Double click on column tags are want to edit.)</small>
          </th>
        )}
        <th className="text-center">Action</th>
      </tr>
    </thead>
  );
}
